import { bluetokaiProfile } from "./bluetokai";
import { defaultProfile } from "./defaultProfile";
import { dotpeProfile } from "./dotpe";
import type { DiscountProviderProfile } from "./types";
import { xenoProfile } from "./xeno";

/**
 * metaId → capability profile.
 *
 * Only providers that DIFFER from the baseline appear here. `reelo` and every provider a merchant
 * enables in future resolve to `defaultProfile` — see `getDiscountProviderProfile`.
 */
export const DISCOUNT_PROVIDER_PROFILES: Record<string, DiscountProviderProfile> = {
  [xenoProfile.metaId]: xenoProfile,
  [bluetokaiProfile.metaId]: bluetokaiProfile,
  [dotpeProfile.metaId]: dotpeProfile,
};

/**
 * The capability profile for a coupon provider.
 *
 * 🔴 **Never throws and never returns undefined.** An unknown, absent or newly-enabled `metaId`
 * answers `defaultProfile` — the plain-coupon shape — so a partner nobody has written a file for
 * still gets a working, conservative flow instead of a request no backend answers. That is the
 * property that makes this registry safe to consult from every rule.
 */
export const getDiscountProviderProfile = (metaId?: string): DiscountProviderProfile =>
  (metaId && DISCOUNT_PROVIDER_PROFILES[metaId]) || defaultProfile;

/** Every profile that has been written, for tests and tooling. Excludes the baseline. */
export const registeredDiscountProfiles = (): DiscountProviderProfile[] =>
  Object.values(DISCOUNT_PROVIDER_PROFILES);
